import {
  initialState,
  Actions,
  State,
  GET_POST_METRICS,
  GET_POST_METRICS_SUCCESS,
  GET_POST_METRICS_ERROR,
  RESET_POST_METRICS,
} from "../../types/post-views/get-metrics";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POST_METRICS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POST_METRICS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POST_METRICS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_POST_METRICS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;

